export default __webpack_public_path__ + "static/media/alert.643a471a.svg";